import React from 'react';

import RBAC from '@common/components/RBAC';

import { useConfig } from '../config';
import { getChatRules } from '../config/ChatRules';
import ChatRules from './Rules';
import * as Styled from './styled';

function ChatTitle() {
	const showChatRules = useConfig(getChatRules);

	return (
		<Styled.Wrap>
			Chat{' '}
			{showChatRules && (
				<RBAC grantedOnly granted={['Student', 'Teacher']}>
					<ChatRules />
				</RBAC>
			)}
		</Styled.Wrap>
	);
}

export default ChatTitle;
